import { render } from "./infoBox.vue?vue&type=template&id=518eedd6"
import script from "./infoBox.vue?vue&type=script&lang=js"
export * from "./infoBox.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__